module.exports = __webpack_public_path__ + "static/media/Card_SecondaryActon_Dots.3a1afd1f.svg";